module.exports = __webpack_public_path__ + "media/images/amenities_icons/bike_parking-d76e710c5979c2e0b71506132ade87f9.svg";